<template>
  <div class="expander">
    <div class="expander-header">
      <h1 :class="expanded ? 'bold' : ''">{{ title }}</h1>
      <img
        :class="expanded ? 'expanded-icon' : ''"
        @click="expanded = !expanded"
        src="@/icons/down-arrow.png"
        alt=""
      />
    </div>
    <slot v-if="expanded" name="content"> </slot>
  </div>
</template>

<script>
export default {
  props: ["title"],
  data() {
    return {
      expanded: false,
    };
  },
};
</script>

<style scoped>
.expander .expander-header {
  display: flex;
}
.expander .expander-header h1 {
  font-weight: 600;
  font-size: 18px;
  color: #090741;
}
.expander-header img {
  width: 30px;
  height: 30px;
  margin-top: -5px;
  margin-left: 20px;
  cursor: pointer;
  transition: 0.4s all;
}
.expanded-icon {
  transform: rotate(-180deg);
}
</style>
